import { useState, useEffect, useRef } from "react";
import { Card, Flex, Button, ConfigProvider, Spin } from "antd";
import { LoadingOutlined, PrinterOutlined } from "@ant-design/icons";
import ItemsTable from "./ItemsTable";
import useFetch from "../../hooks/useFetch";
import formatCurrency from "../../functions/Common/formatCurrency";
import Decimal from 'decimal.js';
import useConnectToPrinter from "../../functions/Printer/connectToPrinter";

export default function SummaryCard(props) {
  const {
    transactionCardRef,
    selectedTransaction,
    setSelectedTransaction,
    plates,
    setPlates,
    selectedPlateIndex,
    setSelectedPlateIndex,
    expandedRowKeys,
    setExpandedRowKeys,
  } = props;

  const gridRef = useRef();
  const tableRef = useRef();
  const [fetchWrapper] = useFetch();
  const { connectToPrinter } = useConnectToPrinter();

  const [tableRefState, setTableRefState] = useState(false);
  const [printLoading, setPrintLoading] = useState(false);

  const onCancelClicked = () => {
    setPlates([]);
    setSelectedTransaction({});
    setSelectedPlateIndex(0);
    setExpandedRowKeys([]);
  };

  const onPreviousClicked = () => {
    setSelectedPlateIndex((prevSelectedPlateIndex) => {
      let newSelectedplateIndex = null;

      if (prevSelectedPlateIndex >= 1) {
        newSelectedplateIndex = prevSelectedPlateIndex - 1;
      } else {
        newSelectedplateIndex = prevSelectedPlateIndex;
      }

      return newSelectedplateIndex;
    });
  };

  const onNextClicked = () => {
    setSelectedPlateIndex((prevSelectedPlateIndex) => {
      let newSelectedplateIndex = null;

      if (prevSelectedPlateIndex + 1 <= plates.length - 1) {
        newSelectedplateIndex = prevSelectedPlateIndex + 1;
      } else {
        newSelectedplateIndex = prevSelectedPlateIndex;
      }

      return newSelectedplateIndex;
    });
  };

  const calculateSubTotal = () => {
    let amount = new Decimal(selectedTransaction?.amount || 0)
    let sst_amount = new Decimal(selectedTransaction?.sst_amount?.toString() || 0)
    let round_adj_amount = new Decimal(selectedTransaction?.round_adj_amount || 0)
    
    return amount.minus(sst_amount).minus(round_adj_amount).toNumber();
  }

  useEffect(() => {
    if (transactionCardRef.current) {
      setTableRefState(true);
    }
  }, [transactionCardRef]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            cellFontSizeSM: 12,
          },
        },
      }}
    >
      <Card
        style={{ height: "100%" }}
        styles={{ body: { height: "calc(100% - 56px)", padding: 0 } }}
        title={
          <Flex gap={"middle"} align="center">
            <>{selectedTransaction?.invoice_no ?? ""}</>
            <Spin
              spinning={
                Object.keys(selectedTransaction).length > 0 &&
                plates.length == 0
              }
              indicator={<LoadingOutlined spin />}
            />
          </Flex>
        }
        extra={
          <Flex gap={"small"}>
            <Button 
              type="primary"
              loading={printLoading}
              style={{fontSize: 18}}
              onClick={()=>{
                connectToPrinter(
                  setPrintLoading,
                  selectedTransaction,
                  plates,
                  fetchWrapper,
                )
              }}
            >
              <PrinterOutlined />
            </Button>

            <Button
              type="primary"
              onClick={onCancelClicked}
              style={{ fontWeight: "bold" }}
              danger
            >
              Close
            </Button>
          </Flex>
          
        }
      >
        <div style={{ height: "100%" }}>
          <Flex justify="space-between" vertical style={{ height: "100%" }}>
            {tableRefState ? (
              <div ref={tableRef}>
                <ItemsTable
                  plates={plates}
                  tableRef={transactionCardRef}
                  tableHeightOffset={16}
                  selectedPlateIndex={selectedPlateIndex}
                  expandedRowKeys={expandedRowKeys}
                  setExpandedRowKeys={setExpandedRowKeys}
                  gridRef={gridRef}
                />
              </div>
            ) : (
              <></>
            )}
            <Card.Grid style={{ width: "100%", padding: 0 }}>
              <div ref={gridRef} style={{ width: "100%", padding: 10 }}>
                {/* <Flex justify="space-between" align="center">
                  <Button onClick={onPreviousClicked}>Previous</Button>
                  {plates.length > 0 && selectedPlateIndex != null
                    ? selectedPlateIndex + 1 + "/" + plates.length
                    : "/"}
                  <Button onClick={onNextClicked}>Next</Button>
                </Flex> */}
                {selectedTransaction?.takeaway_fee ? (
                  <Flex justify="space-between" align="center">
                    <p className="price-summary-title">Takeaway:</p>
                    <p className="price-summary-text">
                      RM {formatCurrency(selectedTransaction?.takeaway_fee)}
                    </p>
                  </Flex>
                ) : (
                  <></>
                )}
                <Flex justify="space-between" align="center">
                  <p className="price-summary-title">Subtotal:</p>
                  <p className="price-summary-text">
                    RM{" "}
                    {formatCurrency(calculateSubTotal())}
                  </p>
                </Flex>
                <Flex justify="space-between" align="center">
                  <p className="price-summary-title">
                    SST-{selectedTransaction.sst_type == "Exclusive"? "excl":"incl"} ({selectedTransaction?.sst_rate}%):
                  </p>
                  <p className="price-summary-text">
                    RM {formatCurrency(selectedTransaction?.sst_amount)}
                  </p>
                </Flex>

                <Flex justify="space-between" align="center">
                  <p className="price-summary-title">
                    Round Adj:
                  </p>
                  <p className="price-summary-text">
                    RM {formatCurrency(selectedTransaction?.round_adj_amount)}
                  </p>
                </Flex>

                <Flex justify="space-between" align="center">
                  <p className="price-summary-title">Pay:</p>
                  <p className="price-summary-text">
                    RM {formatCurrency(selectedTransaction?.pay_amount)}
                  </p>
                </Flex>
                <Flex justify="space-between" align="center">
                  <p className="price-summary-title">Change:</p>
                  <p className="price-summary-text">
                    RM {formatCurrency(selectedTransaction?.change_amount)}
                  </p>
                </Flex>

                <Flex justify="space-between" align="center">
                  <p
                    className="price-summary-title"
                    style={{ fontSize: "2.3vw" }}
                  >
                    Total:
                  </p>
                  <p
                    className="price-summary-text"
                    style={{ fontSize: "2.8vw" }}
                  >
                    RM
                    {formatCurrency(selectedTransaction?.amount)}
                  </p>
                </Flex>
              </div>
            </Card.Grid>
          </Flex>
        </div>
      </Card>
    </ConfigProvider>
  );
}
